<template>
    <div id="modal-support-chat" aria-hidden="true" data-backdrop="false" aria-labelledby="modalFillInLabel" class="modal animation opacity modal-chat" role="dialog" tabindex="-1">
        <div class="modal-dialog">
            <div class="chat-window">
                <header>
                    <span>{{ __('Write to support') }}</span>

                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                        <svg
                            height="16"
                            viewBox="0 0 10 10"
                            width="16"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <defs>
                                <path id="qczca" d="M1110 328l8-8" />
                                <path id="qczcb" d="M1110 320l8 8" />
                            </defs>
                            <g>
                                <g transform="translate(-1109 -319)">
                                    <g>
                                        <use
                                            fill="#fff"
                                            fill-opacity="0"
                                            stroke="#5937B7"
                                            stroke-linecap="square"
                                            stroke-miterlimit="50"
                                            stroke-width="1.5"
                                            xlink:href="#qczca"
                                        />
                                    </g>
                                    <g>
                                        <use
                                            fill="#fff"
                                            fill-opacity="0"
                                            stroke="#5937B7"
                                            stroke-linecap="square"
                                            stroke-miterlimit="50"
                                            stroke-width="1.5"
                                            xlink:href="#qczcb"
                                        />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </button>
                </header>

                <form
                    id="supportChat"
                    action="/feedback"
                    class="contact-form"
                    enctype="multipart/form-data"
                    method="POST"
                >
                    <slot></slot>
                    <div class="chat-content">
                        <form-input-type-text-area
                            v-model="form.subject"
                            name="subject"
                            :label="__('Subject')"
                            auto-grow
                            margin-bottom-double
                            required
                        ></form-input-type-text-area>

                        <form-input-type-text-area
                            v-model="form.description"
                            name="description"
                            :label="__('Describe the problem / suggestion for improvement')"
                            :class="[{'de': currentLocale === 'de'}]"
                            auto-grow
                            margin-bottom-double
                            required
                        ></form-input-type-text-area>

                        <div class="photo-upload">
                            <label class="file" for="files">
                                <svg
                                    height="22px"
                                    version="1.1"
                                    viewBox="0 0 20 22"
                                    width="20px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                >
                                    <g id="Pacient-2.0" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                                        <g
                                            id="5-nastaveni-podpora"
                                            fill="#5937B7"
                                            fill-rule="nonzero"
                                            stroke="#FFFFFF"
                                            transform="translate(-1079.000000, -3770.000000)"
                                        >
                                            <path
                                                id="Path"
                                                d="M1081.73755,3789.20866 C1079.38992,3786.85363 1079.43367,3783.0559 1081.79324,3780.70942 L1090.22109,3772.32814 C1092.00165,3770.55736 1094.89591,3770.55721 1096.67662,3772.32814 C1098.44006,3774.08181 1098.44219,3776.9113 1096.67662,3778.66704 L1089.33001,3785.96594 C1088.13048,3787.15878 1086.17065,3787.14214 1084.99145,3785.92695 C1083.8554,3784.75625 1083.89185,3782.90067 1085.04979,3781.74911 L1090.82518,3776.01337 C1091.07356,3775.76673 1091.48057,3775.76251 1091.73426,3776.00396 L1092.65278,3776.87814 C1092.90651,3777.11962 1092.91081,3777.51532 1092.66246,3777.76196 L1086.88768,3783.49715 C1086.68952,3783.69422 1086.67731,3784.02168 1086.86164,3784.21168 C1087.03731,3784.3927 1087.31345,3784.3957 1087.49197,3784.21813 L1094.83858,3776.91927 C1095.6266,3776.1356 1095.6266,3774.8597 1094.83813,3774.0756 C1094.06715,3773.30892 1092.83093,3773.30853 1092.05963,3774.0756 L1083.63173,3782.45684 C1082.235,3783.8459 1082.21347,3786.09433 1083.58388,3787.46906 C1084.95035,3788.83988 1087.15917,3788.8416 1088.52817,3787.48023 L1095.44129,3780.60528 C1095.68948,3780.35844 1096.09649,3780.35399 1096.35037,3780.59528 L1097.26954,3781.46887 C1097.52343,3781.71016 1097.52805,3782.10586 1097.27982,3782.3527 L1090.3667,3789.22761 C1087.97302,3791.608 1084.10114,3791.57979 1081.73755,3789.20866 Z"
                                            ></path>
                                        </g>
                                    </g>
                                </svg>
                                {{ __('Attach a photo') }}
                            </label>
                            <input id="files" multiple name="files[]" type="file" />
                        </div>

                        <div></div>
                    </div>

                    <footer>
                        <div class="comment-user-input--button">
                            <button id="support-send" type="button" :disabled="!canBeSubmitted" @click="submitForm">
                                <span>
                                    {{ __('Send') }}
                                    <svg
                                        height="42px"
                                        version="1.1"
                                        viewBox="0 0 35 36"
                                        width="42px"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                    >
                                        <title>Group 2</title>
                                        <desc>Created with Sketch.</desc>
                                        <g id="Lympha-stage" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                                            <g id="Vitadio_soukromé-zprávy" transform="translate(-1349.000000, -834.000000)">
                                                <g id="Group-2" transform="translate(1349.000000, 834.000000)">
                                                    <g id="send" fill="#5937B7" transform="translate(9.000000, 10.000000)">
                                                        <path
                                                            id="Path"
                                                            d="M18.808889,6.74023189 L2.67240008,0.14676662 C1.9925952,-0.131035178 1.22458717,-0.0088285438 0.668141704,0.465534759 C0.111696234,0.939974994 -0.121038206,1.67098377 0.0608368451,2.37325841 L1.49712631,7.91975479 L8.52939392,7.91975479 C8.85298776,7.91975479 9.11537065,8.17809277 9.11537065,8.49678397 C9.11537065,8.81543671 8.85302682,9.07381316 8.52939392,9.07381316 L1.49712631,9.07381316 L0.0608368451,14.6202711 C-0.121038206,15.3225842 0.111657172,16.053593 0.668141704,16.5279947 C1.22571999,17.0033197 1.99380614,17.1240261 2.67243914,16.8467629 L18.8089281,10.2533361 C19.5436158,9.95314701 19.9999831,9.28006811 19.9999831,8.49678397 C19.9999831,7.71349984 19.5436158,7.04038247 18.808889,6.74023189 Z"
                                                        ></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </footer>
                </form>
                <!-- /.modal-dialog -->
            </div>
        </div>
    </div>
</template>

<script>
import localforage from 'localforage'

export default {
    props: [
        'showBackdrop'
    ],
    data() {
        return {
            storageKey: 'feedback-form',
            form: {
                subject: null,
                description: null
            },
            open: false,
            backdrop: this.showBackdrop !== false,
            currentLocale: window.locale,
            storageLoaded: false
        }
    },
    computed: {
        canBeSubmitted() {
            return this.form.subject && this.form.description
        }
    },
    watch: {
        form: {
            handler() {
                this.updateStorage(this.form)
            },
            deep: true
        },
        open() {
            this.updateStorage({ open: this.open })
        }
    },
    mounted() {
        $(async () => {
            $('#feedback-delete-button').click(async () => {
                this.form = {
                    subject: null,
                    description: null
                }

                await this.$nextTick()

                this.open = false

                $('#files').fileinput('clear')
            })

            $('#feedback-back-button').click(function() {
                $('#modal-support-chat').modal('show')
                $('#close-alert').modal('hide')
            })

            $(this.$el).find('.close').click(() => {
                if ($('#description').val() != '' || $('#subject').val() != '' || $('#files').val() != '') {
                    $('#close-alert').modal('show')
                } else {
                    this.open = false
                    $('#modal-support-chat').modal('dispose')
                }
            })

            $('#modal-support-chat').on('shown.bs.modal', () => {
                $('.desktop').addClass('modal-overflow')
                this.open = true
            })

            $('#modal-support-chat').on('hidden.bs.modal', () => {
                $('.desktop').removeClass('modal-overflow')
            })

            $(this.$el).find('#subject').on('input', function() {
                if ($('#description').val() != '' && $('#subject').val() != '') {
                    $('#support-send').attr('disabled', false)
                } else {
                    $('#support-send').attr('disabled', true)
                }
            })

            $(this.$el).find('#description').on('input', function() {
                if ($('#description').val() != '' && $('#subject').val() != '') {
                    $('#support-send').attr('disabled', false)
                } else {
                    $('#support-send').attr('disabled', true)
                }
            })

            await this.loadFromStorage()

            if (this.open) {
                $('#modal-support-chat').modal('show')
            }

            $(this.$el).find('#files').fileinput({
                showZoom: false,
                showUpload: false,
                showCancel: false,
                showRemove: false,
                showCaption: false,
                dropZoneEnabled: false,
                retryErrorUploads: false,
                removeFromPreviewOnError: true,
                uploadUrl: '/site/test-upload',
                allowedPreviewTypes: ['image'],
                allowedFileExtensions: ['jpg', 'jpeg', 'png', 'pdf'],
                language: _.get(window, 'locale', 'cs'),
                maxFileSize: 10000,
                layoutTemplates: {
                    main1:
                        '<span class="file-title">' +
                        lang.get('Attach file') +
                        '</span>\n{preview}\n' +
                        '<div class="kv-upload-progress kv-hidden"></div><div class="clearfix"></div>\n' +
                        '<div class="input-group {class}">\n' +
                        '  {caption}\n' +
                        '</div>',
                    main2:
                        '<span class="file-title">' +
                        lang.get('Attach file') +
                        '</span>{preview}\n<div class="kv-upload-progress hide"></div>',
                    size: '<samp>{sizeText}</samp>',
                    actions:
                        '<div class="file-actions">\n' +
                        '    <div class="file-footer-buttons">\n' +
                        '        {delete}' +
                        '    </div>\n' +
                        '    <div class="clearfix"></div>\n' +
                        '</div>',
                    preview:
                        '<div class="file-preview {class}">\n' +
                        '    <div class="{dropClass}">\n' +
                        '    <div class="file-preview-thumbnails">\n' +
                        '    </div>\n' +
                        '    {browse}' +
                        '    <div class="clearfix"></div>' +
                        '    <div class="file-preview-status text-center text-success"></div>\n' +
                        '    <div class="kv-fileinput-error"></div>\n' +
                        '    </div>\n' +
                        '</div>'
                },
                previewFileIconSettings: {
                    pdf:
                        '<svg width="28px" height="36px" viewBox="0 0 28 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>FEBBB219-DE67-469C-8384-D2544C3723C4</title> <g id="Android-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="2020-05_diskuse-priloha" transform="translate(-30.000000, -286.000000)"><g id="file-extension" transform="translate(30.000000, 286.000000)"><path d="M1.77556129,0 L20.1318194,0 L27.9943097,7.83196129 L27.9943097,34.1879484 C27.9943097,35.1525032 27.2122065,35.9337935 26.2484645,35.9337935 L1.77556129,35.9337935 C0.811819355,35.9337935 0.029716129,35.1525032 0.029716129,34.1879484 L0.029716129,1.74584516 C0.029716129,0.781290323 0.811909677,0 1.77556129,0 Z" id="Path" fill="#E2574C" fill-rule="nonzero"></path> <text id="PDF" font-family="Nunito-Black, Nunito" font-size="10" font-weight="700" line-spacing="16" fill="#FFFFFF"><tspan x="3.86" y="21">PDF</tspan></text> <path d="M27.9691097,7.85634839 L21.8838968,7.85634839 C20.9201548,7.85634839 20.1380516,7.07424516 20.1380516,6.11050323 L20.1380516,0.0174322581 L27.9691097,7.85634839 Z" id="Path" fill="#B53629" fill-rule="nonzero"></path></g></g></g></svg>'
                },
                ajaxDeleteSettings: {
                    type: 'DELETE'
                }
            })
        })
    },
    methods: {
        submitForm() {
            this.resetStorage()

            $('#supportChat').submit()
        },
        async loadFromStorage() {
            const { subject, description, open } = (await localforage.getItem(this.storageKey)) || {}

            this.open = open
            this.form = { subject, description }

            await this.$nextTick()

            this.storageLoaded = true
        },
        updateStorage(data) {
            if (!this.storageLoaded) {
                return
            }

            localforage.setItem(this.storageKey, {
                open: this.open,
                ...this.form,
                ...data
            })
        },
        resetStorage(data) {
            localforage.setItem(this.storageKey, {
                open: false,
                subject: '',
                description: ''
            })
        }
    }
}
</script>
